import { Guid } from 'guid-typescript';
import { IdTokenClaims } from 'src/app/features/msal-auth/models';

export interface CorrelationHeaderInputs {
  packageGuid: string | null | undefined;
  packageUserGuid: string | null | undefined;
  deviceCode: string | null | undefined;
  packageId: number | null | undefined;
  idTokenClaims: IdTokenClaims | null | undefined;
}

/** Shared by BaseUrlInterceptor and AvTelemetryUploaderService so the two can't drift (299440). */
export function buildCorrelationHeaders(inputs: CorrelationHeaderInputs): Record<string, string> {
  return {
    'auth-settings': 'user-bearer',
    'package-guid': `${inputs.packageGuid ?? inputs.idTokenClaims?.extension_PackageGuid}`,
    'package-user-guid': `${inputs.packageUserGuid}`,
    'device-code': `${inputs.deviceCode ?? Guid.EMPTY}`,
    'package-id': `${inputs.packageId}`,
  };
}
